import React from 'react';

import { Grid, Typography } from '@material-ui/core';

import { TextField, SelectField, DateField, Step } from '../SteppedForm';

import rules from './rules';

const StepVehicleold = (props) => {
  return (
    <Step
      id="vehicleold"
      title="Replaced Vehicle Details"
      skip={(formdata) =>
        formdata.vehicles[props.state.vehicle_index].plate === '13cabs' ||
        formdata.onboardcar === false ||
        formdata.tiger === true ||
        props.stateconfig().oldcar !== true ||
        formdata.vehicles[props.state.vehicle_index].car_replace === false ||
        formdata.vehicles[props.state.vehicle_index].carbuy
      }>
      <Typography variant="body1" class="formQuestion">
        If you are using existing plates on a new vehicle, please provide the details of the
        previous vehicle so we can complete required TMR forms for you.
      </Typography>
      <Grid container>
        <Grid item xs={12} lg={6}>
          <TextField
            id="old_rego"
            modify={(value) => props.toUpperCase(value)}
            label="Registration"
            valid={rules.alphanumeric}
            required
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <DateField
            id="old_manudate"
            label="Manufacture Date"
            format="MM/YYYY"
            disableFuture
            required
          />
        </Grid>

        <Grid item xs={12} lg={4}>
          <div className="composite even">
            <SelectField
              id="old_make"
              label="Make"
              values={Object.keys(props.getMakes())}
              required
            />
            {props.getVehicle().old_make === 'Other' ? (
              <TextField id="old_makeother" label="Make Details" valid={rules.safeText} required />
            ) : (
              ''
            )}
          </div>
        </Grid>
        <Grid item xs={12} lg={4}>
          <div className="composite even">
            {props.getVehicle().old_make !== 'Other' ? (
              <SelectField
                id="old_model"
                label="Model"
                disabled={!props.getVehicle().old_make}
                values={
                  props.getVehicle().old_make && props.getMakes()[props.getVehicle().old_make]
                    ? props.getMakes()[props.getVehicle().old_make]
                    : []
                }
                required
              />
            ) : (
              ''
            )}

            {props.getVehicle().old_make &&
            (props.getVehicle().old_model === 'Other' ||
              !props.getMakes()[props.getVehicle().old_make] ||
              props.getMakes()[props.getVehicle().old_make].length === 0) ? (
              <TextField
                id="old_modelother"
                label={props.getVehicle().old_make === 'Other' ? 'Model' : 'Model Details'}
                valid={rules.safeText}
                required
              />
            ) : (
              ''
            )}
          </div>
        </Grid>

        <Grid item xs={12} lg={3}>
          <SelectField
            id="old_shape"
            label="Shape"
            values={
              props.networkconfig().wats
                ? [...props.config.vehicle_shapes, 'Wheelchair']
                : props.config.vehicle_shapes
            }
          />
        </Grid>
        <Grid item xs={12} lg={props.getVehicle().old_shape === 'Wheelchair' ? 4 : 6}>
          <TextField
            id="old_frontseats"
            label="# of Front Passenger Seats"
            type="number"
            valid={rules.numeric_bounded(0, 15)}
            required
          />
        </Grid>
        <Grid item xs={12} lg={props.getVehicle().old_shape === 'Wheelchair' ? 4 : 6}>
          <TextField
            id="old_rearseats"
            label="# of Rear Passenger Seats"
            type="number"
            valid={rules.numeric_bounded(0, 15)}
            required
          />
        </Grid>
        {props.getVehicle().old_shape === 'Wheelchair' ? (
          <Grid item xs={12} lg={4}>
            <TextField
              id="old_wheelchairs"
              label="# of Wheelchairs"
              type="number"
              valid={rules.numeric_bounded(1, 4)}
              required
            />
          </Grid>
        ) : (
          ''
        )}
        <Grid item xs={12} lg={4}>
          <SelectField id="old_lease" label="Lease Type" values={props.config.leases} />
        </Grid>
        <Grid item xs={12} lg={4}>
          <DateField id="old_leaseend" label="Lease Start Date" />
        </Grid>
        <Grid item xs={12} lg={4}>
          <DateField id="old_onroad" label="On Road Date" />
        </Grid>
      </Grid>
    </Step>
  );
};

export default StepVehicleold;
